import axios from "axios";
import toast from "react-hot-toast";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // https://mizusmart.com/
  withCredentials: false, // not needed for Bearer auth
});

api.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("MCData");

    if (raw) {
      const parsed = JSON.parse(raw);

      if (parsed?.token) {
        config.headers.Authorization = `Bearer ${parsed.token}`;
        config.headers["District"] = parsed.selectedDistrict || "";
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      toast.error("Session expired. Please login again.");
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export default api;
